import { Helmet } from "react-helmet-async";
import React from "react";
import PropTypes from "prop-types";
PrivatePageTitle.propTypes = {
    title: PropTypes.string.isRequired
};
export default function PrivatePageTitle(param) {
    var title = param.title;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Helmet, null, /*#__PURE__*/ React.createElement("title", null, title)), /*#__PURE__*/ React.createElement("h1", {
        className: "my-2 text-center text-2xl font-semibold md:text-left md:text-3xl"
    }, title));
}
